import Vue from 'vue';
import Router from 'vue-router';
import Cookie from 'vue-cookie';
import Layout from '@/components/Layout';
import Home from '@/components/Home';
import LogIn from '@/components/LogIn';
import SignUp from '@/components/SignUp';
import FixedLayout from '@/components/FixedLayout';

import Accounts from '@/components/accounts/Accounts';
import AccountDetails from '@/components/accounts/AccountDetails';

import AppResource from '@/components/appResource/AppResource';
import AppResourceDetails from '@/components/appResource/AppResourceDetails';

import AuditLog from '@/components/audit/AuditLog';

import AutoJob from '@/components/autoJob/AutoJob';

import Companies from '@/components/company/Companies';
import CompanyDetails from '@/components/company/CompanyDetails';

import ConfigUpdates from '@/components/configUpdates/ConfigUpdates';

import Corporations from '@/components/corporations/Corporations'
import CorporationDetails from '@/components/corporations/CorporationDetails'

import CallerIdServers from '@/components/callerID/CallerIdServers';
import CallerIdDetails from '@/components/callerID/CallerIdDetails';

import DiscountRules from '@/components/discountRules/DiscountRules';
import DiscountRuleDetails from '@/components/discountRules/DiscountRuleDetails';

import Domains from '@/components/domains/Domains';
import NewDomain from '@/components/domains/NewDomain';

import LanguageMappings from '@/components/languageMappings/LanguageMappings';
import LanguageMappingDetails from '@/components/languageMappings/LanguageMappingDetails';

import Licenses from '@/components/licenses/Licenses';
import LicenseDetails from '@/components/licenses/LicenseDetails';

import LicenseReports from '@/components/licenses/LicenseReports';

import MoonInstnces from '@/components/moonInstances/MoonInstances';
import MoonInstanceDetails from '@/components/moonInstances/MoonInstanceDetails';

import Invoices from '@/components/invoices/Invoices';

import Images from '@/components/images/Images';
import ImageDetails from '@/components/images/ImageDetails';

import PaymentTerminals from '@/components/paymentTerminals/PaymentTerminals';
import PaymentTerminalDetails from '@/components/paymentTerminals/PaymentTerminalDetails';

import Printers from '@/components/printers/Printers';
import PrinterDetails from '@/components/printers/PrinterDetails';

import PrintTemplates from '@/components/printTemplates/PrintTemplates';
import PrintTemplateDetails from '@/components/printTemplates/PrintTemplateDetails';

import PrintServers from '@/components/printServers/PrintServers';
import PrintServerDetails from '@/components/printServers/PrintServerDetails';

import PaymentServers from '@/components/paymentServers/PaymentServers';
import PaymentServerDetails from '@/components/paymentServers/PaymentServerDetails';

import ResourceTracking from '@/components/resourceTracking/ResourceTracking';

import WebshopReports from '@/components/webshopReports/WebshopReports';

import Tables from '@/components/tables/Tables';
import TableDetails from '@/components/tables/TableDetail';
import TableCategories from '@/components/tables/TableCategories';
import TableCategoryDetail from '@/components/tables/TableCategoryDetail';

import SystemLogs from '@/components/systemLogs/SystemLogs';

import WebShop from '@/components/webShop/WebShop';
import WebShopDetail from '@/components/webShop/WebShopDetail';
import WebShopOrder from '@/components/webShop/WebShopOrder';

import WebSpaces from '@/components/webSpace/WebSpaces';
import NewWebSpace from '@/components/webSpace/NewWebSpace';

import CatalogList from '@/components/catalog/List';
import CatalogSingle from '@/components/catalog/Single';

import CashRegister from '@/components/cashRegister/CashRegister';
import CashRegisterDetails from '@/components/cashRegister/CashRegisterDetails';

import Page404 from '@/components/404';

import blocks from './role-map';

Vue.use(Router);

const lang = Cookie.get('lang') || 'en';

const shouldBlock = (route) => {
  const roles = Cookie.get('roles') || [];
  const currentGuard = blocks.find(block => block.path === route);
  if (!currentGuard) return false;
  let shouldBlock = true;
  currentGuard.roles.forEach((role) => {
    if (roles.includes(role)) shouldBlock = false;
  });
  return shouldBlock;
};

export default new Router({
  routes: [
    {
      path: '/',
      redirect: `/${lang}`,
    },
    {
      path: '/log-in',
      name: 'logIn',
      component: LogIn,
      // If logged in, redirect
      beforeEnter: (to, from, next) => {
        if (!!Cookie.get('uuid')) {
          next({ name: 'home' });
        } else {
          next();
        }
      },
    },
    {
      path: '/log-out',
      name: 'logOut',
      // Log out and redirect
      beforeEnter: (to, from, next) => {
        Cookie.delete('uuid');
        Cookie.delete('roles');
        localStorage.removeItem('currentUser');
        next({ name: 'logIn' });
      },
    },
    {
      path: '/sign-up',
      name: 'signUp',
      component: SignUp,
    },
    {
      path: '/:lang',
      component: Layout,
      // If not logged in, redirect
      beforeEnter: (to, from, next) => {
        if (!!Cookie.get('uuid')) {
          next();
        } else {
          next({ name: 'logIn' });
        }
      },
      children: [
        {
          path: '',
          name: 'home',
          component: Home,
        },
        {
          path: 'accounts',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('accounts')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: Accounts,
              name: 'accounts'
            },
            {
              path: 'create',
              component: AccountDetails,
              name: 'createAccount',
            },
            {
              path: 'edit/:id',
              component: AccountDetails,
              name: 'editAccunt',
            },
          ],
        },
        {
          path: 'app-resources',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('app-resources')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: AppResource,
              name: 'appResources',
            },
            {
              path: 'create',
              component: AppResourceDetails,
              name: 'appResourceCreate',
            },
            {
              path: 'edit/:id',
              component: AppResourceDetails,
              name: 'appResourceEdit',
            },
          ],
        },
        {
          path: 'audit-log',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('audit-log')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: AuditLog,
              name: 'auditLog'
            },
          ],
        },
        {
          path: 'auto-jobs',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('auto-jobs')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: AutoJob,
              name: 'autoJobs'
            },
          ],
        },
        {
          path: 'companies',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('companies')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: Companies,
              name: 'companies'
            },
            {
              path: 'create',
              component: CompanyDetails,
              name: 'createCompany',
            },
            {
              path: 'edit/:id',
              component: CompanyDetails,
              name: 'editCompany',
            },
          ],
        },
        {
          path: 'catalog',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('catalog')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              redirect: { name: 'catalogList' },
            },
            {
              path: 'list',
              component: CatalogList,
              name: 'catalogList',
            },
            {
              path: 'create',
              component: CatalogSingle,
              name: 'catalogCreate',
            },
          ],
        },
        {
          path: 'caller-id-servers',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('caller-id-servers')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: CallerIdServers,
              name: 'callerIdServers',
            },
            {
              path: 'create',
              component: CallerIdDetails,
              name: 'callerIdCreate',
            },
            {
              path: 'edit/:id',
              component: CallerIdDetails,
              name: 'callerIdEdit',
            },
          ],
        },
        {
          path: 'corporations',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('corporations')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: Corporations,
              name: 'corporations',
            },
            {
              path: 'create',
              component: CorporationDetails,
              name: 'corporationCreate',
            },
            {
              path: 'edit/:id',
              component: CorporationDetails,
              name: 'corporationEdit',
            },
          ],
        },
        {
          path: 'config-updates',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('config-updates')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: ConfigUpdates,
              name: 'configUpdates',
            },
          ],
        },
        {
          path: 'discount',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('discount')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: DiscountRules,
              name: 'discountRules',
            },
            {
              path: 'create',
              component: DiscountRuleDetails,
              name: 'discountCreate',
            },
            {
              path: 'edit/:id',
              component: DiscountRuleDetails,
              name: 'discountEdit',
            },
          ],
        },
        {
          path: 'domain-dashboard',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('domain-dashboard')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: Domains,
              name: 'domains',
            },
            {
              path: 'domain-create',
              component: NewDomain,
              name: 'newDomain',
            },
            {
              path: 'domain-edit/:id',
              component: NewDomain,
              name: 'editDomain',
            },
          ],
        },
        {
          path: 'language-mappings',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('language-mappings')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: LanguageMappings,
              name: 'languageMappings',
            },
            {
              path: 'create',
              component: LanguageMappingDetails,
              name: 'languageMappingCreate',
            },
            {
              path: 'edit/:id',
              component: LanguageMappingDetails,
              name: 'languageMappingEdit',
            },
          ],
        },
        {
          path: 'webshopusage-reports',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('webshopusage-reports')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: WebshopReports,
              name: 'webshopReports',
            },
          ],
        },
        {
          path: 'licenses',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('licenses')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: Licenses,
              name: 'licenses',
            },
            {
              path: 'license-create',
              component: LicenseDetails,
              name: 'licenseCreate',
            },
            {
              path: 'license/:id',
              component: LicenseDetails,
              name: 'license',
            },
          ],
        },
        {
          path: 'license-reports',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('license-reports')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: LicenseReports,
              name: 'licenseReports',
            },
          ],
        },
        {
          path: 'invoices',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('invoices')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: Invoices,
              name: 'invoices',
            },
          ],
        },
        {
          path: 'images',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('images')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: Images,
              name: 'images',
            },
            {
              path: 'create',
              component: ImageDetails,
              name: 'imageCreate',
            },
            {
              path: 'edit/:id',
              component: ImageDetails,
              name: 'image',
            },
          ],
        },
        {
          path: 'payment-terminals',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('paymentTerminals')) {
              next();
            } else {
              next({ name: 'home' });
            }
            },
          children: [
            {
              path: '',
              component: PaymentTerminals,
              name: 'paymentTerminals',
            },
            {
              path: 'create',
              component: PaymentTerminalDetails,
              name: 'paymentTerminalCreate',
            },
            {
              path: 'edit/:id',
              component: PaymentTerminalDetails,
              name: 'paymentTerminal',
            },
          ],
        },
        {
          path: 'payment-servers',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('paymentServers')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: PaymentServers,
              name: 'paymentServers',
            },
            {
              path: 'create',
              component: PaymentServerDetails,
              name: 'paymentServerCreate',
            },
            {
              path: 'edit/:id',
              component: PaymentServerDetails,
              name: 'paymentServer',
            },
          ],
        },
        {
          path: 'printers',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('printers')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: Printers,
              name: 'printers',
            },
            {
              path: 'create',
              component: PrinterDetails,
              name: 'printerCreate',
            },
            {
              path: 'edit/:id',
              component: PrinterDetails,
              name: 'printer',
            },
          ],
        },
        {
          path: 'print-servers',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('print-servers')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: PrintServers,
              name: 'printServers',
            },
            {
              path: 'create',
              component: PrintServerDetails,
              name: 'printServerCreate',
            },
            {
              path: 'edit/:id',
              component: PrintServerDetails,
              name: 'printServer',
            },
          ],
        },
        {
          path: 'print-templates',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('print-templates')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: PrintTemplates,
              name: 'printTemplates',
            },
            {
              path: 'create',
              component: PrintTemplateDetails,
              name: 'printTemplateCreate',
            },
            {
              path: 'view/:id',
              component: PrintTemplateDetails,
              name: 'printTemplate',
            },
            {
              path: 'clone/:id',
              component: PrintTemplateDetails,
              name: 'printTemplateClone',
            },
          ],
        },
        {
          path: 'web-space-dashboard',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('web-space-dashboard')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: WebSpaces,
              name: 'webSpaces',
            },
            {
              path: 'web-space-create',
              component: NewWebSpace,
              name: 'newWebSpace',
            },
            {
              path: 'web-space-edit/:id',
              component: NewWebSpace,
              name: 'editWebSpace',
            },
          ],
        },
        {
          path: 'tables',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('tables')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: Tables,
              name: 'tables',
            },
            {
              path: 'create',
              component: TableDetails,
              name: 'tableDetailsCreate',
            },
            {
              path: 'edit/:id',
              component: TableDetails,
              name: 'tableDetails',
            },
          ],
        },
        {
          path: 'table-categories',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('table-categories')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: TableCategories,
              name: 'tableCategories',
            },
            {
              path: 'table-category-create',
              component: TableCategoryDetail,
              name: 'tableCategoryCreate',
            },
            {
              path: 'table-category-edit/:id',
              component: TableCategoryDetail,
              name: 'tableCategoryUpdate',
            },
          ],
        },
        {
          path: 'moon-instance-dashboard',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('moon-instance-dashboard')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: MoonInstnces,
              name: 'moonInstances',
            },
            {
              path: 'moon-instance-detail/:id',
              component: MoonInstanceDetails,
              name: 'moonInstanceDetails',
            },
          ],
        },
        {
          path: 'resource-tracking',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('resource-tracking')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: ResourceTracking,
              name: 'resourceTracking',
            },
          ],
        },
        {
          path: 'system-logs',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('system-logs')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: SystemLogs,
              name: 'systemLogs',
            },
          ],
        },
        {
          path: 'web-shop-dashboard',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('web-shop-dashboard')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: WebShop,
              name: 'webShop',
            },
            {
              path: 'web-shop-create',
              component: WebShopDetail,
              name: 'webShopDetail',
            },
            {
              path: 'web-shop-edit/:id',
              component: WebShopDetail,
              name: 'webShopEdit',
            },
            {
              path: 'web-shop-order/:id',
              component: WebShopOrder,
              name: 'webShopOrder',
            },
          ],
        },
        {
          path: 'cash-register',
          component: FixedLayout,
          beforeEnter: (to, from, next) => {
            if (!shouldBlock('cash-register')) {
              next();
            } else {
              next({ name: 'home' });
            }
          },
          children: [
            {
              path: '',
              component: CashRegister,
              name: 'cashRegister',
            },
            {
              path: 'cash-register-create',
              component: CashRegisterDetails,
              name: 'cashRegisterCreate',
            },
            {
              path: 'cash-register-edit/:id',
              component: CashRegisterDetails,
              name: 'cashRegisterEdit',
            },
          ],
        },
      ],
    },
    {
      path: '*',
      component: Layout,
      children: [
        {
          path: '',
          component: Page404,
          name: 'error-page'
        },
      ],
    },
  ],
  mode: 'history',
});



// WEBPACK FOOTER //
// ./src/router/index.js